import { Caption } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import {
    getItemModelBidCount,
    getItemModelIsLocked,
    getItemModelIsPassed,
    getItemModelIsPaused,
    getItemModelIsSold,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { getLiveItemStatusOpen } from '@/redux/modules/liveItemStatus';
import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { useAppSelector } from '@/redux/hooks';
import ItemCardMenu from '@/components/ItemCard/components/Menu/ItemCardMenu';
import ItemCardPriceRow from '@/components/GridItemCard/Card/components/ItemCardPriceRow/ItemCardPriceRow';
import styled from 'styled-components';

export type CardPriceProps = {
    enterLinkHoverState: () => void;
    isCardHovered: boolean;
    isLinkHovered: boolean;
    isMobile: boolean;
    itemId: number;
    leaveLinkHoverState: () => void;
};

const CardPrice = ({
    enterLinkHoverState,
    isCardHovered,
    isLinkHovered,
    isMobile,
    itemId,
    leaveLinkHoverState,
}: CardPriceProps) => {
    const isLoggedIn = useAppSelector(isUserLoggedIn);
    const bidCount = useAppSelector((state) => getItemModelBidCount(state, itemId));
    const isSold = useAppSelector((state) => getItemModelIsSold(state, itemId));
    const isPassed = useAppSelector((state) => getItemModelIsPassed(state, itemId));
    const isPaused = useAppSelector((state) => getItemModelIsPaused(state, itemId));
    const isLocked = useAppSelector((state) => getItemModelIsLocked(state, itemId));

    const isLotOpen = useAppSelector((state) => getLiveItemStatusOpen(state, itemId));

    const isPending = isLocked && !isPassed && !isSold && !isLotOpen;

    return (
        <PriceInformation data-testid="timedPlusMyItemsCardPrice">
            <StyledBidInfo>
                <ItemCardPriceRow
                    isHovered={isLinkHovered}
                    itemId={itemId}
                    onMouseEnter={enterLinkHoverState}
                    onMouseLeave={leaveLinkHoverState}
                />
                {!isSold && !isPassed && !isPending && !isPaused && bidCount > 0 && (
                    <StyledBidCount
                        color="secondary"
                        data-testid="timedPlusMyItemCardBidCount"
                    >
                        <FormattedMessage
                            id="itemBidding.bid"
                            values={{ bidCount }}
                        />
                    </StyledBidCount>
                )}
            </StyledBidInfo>
            {isLoggedIn && !isMobile && (
                <ItemCardMenu
                    itemId={itemId}
                    showIcon={isCardHovered}
                />
            )}
        </PriceInformation>
    );
};

export default CardPrice;

const StyledBidInfo = styled.section`
    display: flex;
    align-items: center;
`;

const PriceInformation = styled.section`
    grid-area: currentbidprice;
    display: flex;
    justify-content: space-between;
`;

const StyledBidCount = styled(Caption)`
    margin-left: 4px;
`;
